module.exports = "<div> <span ng-if=::vm.address.addressLine1>{{ vm.address.addressLine1 }}</span> <span ng-if=::vm.address.addressLine2><br/>{{ ::vm.address.addressLine2 }}</span> <span ng-if=::vm.address.postalCode><br/>{{ ::vm.address.postalCode }} {{ ::vm.address.cityName }}</span> <span ng-if=::vm.address.countryName><br/>{{ ::vm.address.countryName }}</span> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/common/address.html
// module id = 578
// module chunks = 0